import { DevicePid, VK } from "@/define/define"
import { KeyZone } from "@libs/types/enum"
import { DeviceManager, DeviceProtocol } from "./device"
import { KeyZoneData } from "@libs/types/response"

export interface IKeyZone {
    Data: { [index: VK]: KeyZoneData }
    Filter: { [index: VK]: KeyZone[] }
}
export class DeviceZone {

    private hidKeyZones: Map<KeyZone, VK[]> = new Map<KeyZone, VK[]>();
    private hidFilter: Map<DevicePid, VK[]> = new Map<DevicePid, VK[]>

    private exeKeyZones: Map<KeyZone, VK[]> = new Map<KeyZone, VK[]>
    private exeFilter: Map<DevicePid, VK[]> = new Map<DevicePid, VK[]>

    getKeysOrDefault = (zoneKey: KeyZone, defaultKeys: VK[]): VK[] => {

        const protocol = DeviceManager.instance.state.driverProtocol
        let keyZoneValue = protocol === DeviceProtocol.dll_exe ? this.exeKeyZones : this.hidKeyZones;
        let filter = protocol === DeviceProtocol.dll_exe ? this.exeFilter : this.hidFilter;

        const nonKeys: VK[] = filter.get(DeviceManager.instance.state.currentPid) || [];
        let keys: VK[] = keyZoneValue.get(zoneKey) || []
        keys = keys.filter(vk => !nonKeys.includes(vk))
        return keys.length > 0 ? keys : defaultKeys;
    }

    private sortDataByOrder(message: { [index: VK]: KeyZoneData }): Map<VK, KeyZoneData> {
        const sortedEntries = Object.entries(message)
            .map(([key, value]) => [Number(key), value] as [number, KeyZoneData])
            .sort(([, a], [, b]) => a.Order - b.Order);
        return new Map<number, KeyZoneData>(sortedEntries);
    }

    askDefineZones(res: IKeyZone, protocol: DeviceProtocol) {
        const data = this.sortDataByOrder(res.Data);
        const filter = new Map<DevicePid, VK[]>(Object.entries(res.Filter).map(([key, value]) => [Number(key), value as VK[]]))

        if (protocol === DeviceProtocol.hid_web) {
            this.hidKeyZones = this.handleKeyZones(data);
            this.hidFilter = filter
        }
        if (protocol === DeviceProtocol.dll_exe) {
            this.exeKeyZones = this.handleKeyZones(data);
            this.exeFilter = filter
        }
    }

    private handleKeyZones = (res: Map<VK, KeyZoneData>): Map<KeyZone, VK[]> => {
        const keyZones = new Map<KeyZone, VK[]>();
        for (const [vk, keyZoneData] of res) {
            keyZoneData.Zone.forEach(zones => {
                if (keyZones.has(zones)) {
                    keyZones.get(zones)?.push(vk)
                } else {
                    keyZones.set(zones, [vk])
                }
            })
        }
        return keyZones
    }
}
const zone = new DeviceZone()
export const deviceZone = zone
